
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';

@Component({
  selector: 'app-campaign-3-search-products',
  templateUrl: './campaign-3-search-products.component.html',
  styleUrls: ['./campaign-3-search-products.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchProductsComponent implements OnInit {

  @Input() productsList: Array<any> = [];
  @Output() productsListSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() productsListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() rowSelected = { identifierField: 'id', arrayValues: [] };

  @ViewChild('productsListTable') productsListTable: Campaign3KontableComponent;

  // Lista locale per la selezione temporanea
  tempProductSelected: Array<any> = [];
  paginationType: number = Campaign3KontableComponent.ServerPagination;

  show = {
    table: false
  };

  constructor(private srvCampaign: Campaign3Service) {}

  ngOnInit() {
    // Clona la selezione iniziale per lavorare su copia locale
    this.tempProductSelected = this.rowSelected.arrayValues.map(pr => Object.assign({}, pr));
    this.show.table = true;
  }

  // Gestione selezione riga nella tabella
  onProductsSelected(product: any) {
    const index = this.tempProductSelected.findIndex(x => x.id === product.id);

    if (!product.rowSelected) {
      if (index > -1) this.tempProductSelected.splice(index, 1);
    } else {
      if (index === -1) this.tempProductSelected.push(Object.assign({}, product));
    }

    console.log(this.tempProductSelected);
  }

  // Conferma selezione e invio al padre
  onClickAggiungiProducts() {
    this.productsListSelected.emit(this.tempProductSelected.map(pr => Object.assign({}, pr)));
  }

  // Annulla selezione: chiude la modal senza modificare il padre
  onClickAnnullaProducts() {
    this.productsListCancel.emit(true);
  }

onRefreshTable(refreshed: boolean) {
  if (refreshed && this.productsListTable) {
    // Usa tempProductSelected come fonte di verità per sincronizzare la tabella
    for (let prodSel of this.tempProductSelected) {
      const rowSel = this.productsListTable.filteredData.find(
        x => x[this.rowSelected.identifierField] === prodSel[this.rowSelected.identifierField]
      );
      if (rowSel) {
        rowSel.rowSelected = true;
      }
    }
    
    // Assicurati che le righe non in tempProductSelected siano deselezionate
    for (let row of this.productsListTable.filteredData) {
      if (!this.tempProductSelected.find(x => x[this.rowSelected.identifierField] === row[this.rowSelected.identifierField])) {
        row.rowSelected = false;
      }
    }
  }
}
  onTableRendered() {
    this.onRefreshTable(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-products/campaign-3-search-products.component.ts